"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M5.01 3c-.41 0-.77.12-1.05.4-.27.29-.39.67-.39 1.1 0 .29.05.56.18.79.13.23.3.41.52.53.22.12.47.18.72.18.41 0 .77-.12 1.04-.41.28-.29.39-.67.39-1.1 0-.29-.05-.55-.18-.79-.12-.22-.29-.4-.51-.52-.22-.12-.46-.18-.72-.18zM6.2 7c.3736 0 .7029.2085.8725.52l2.651 4.1422 4.5429.0011L16.92 7.534c.1673-.3192.5009-.534.88-.534h2.4c.47 0 .87.33.97.78L23 16h-3v5h-2v-5h-3l1.0281-4.6179-1.0354 1.6112h-.9936c.0091 1.5577.0005 3.1156.0005 4.6734h-1.3334V21h-1.3333v-3.3333H9.9996c0-1.5579-.0166-3.1167.0008-4.6745H8.9956l-1.02-1.5939L9 16H6v5H4v-5H1l1.83-8.22c.1-.45.5-.78.97-.78h2.4zm12.81-4c-.41 0-.77.12-1.05.4-.27.29-.39.67-.39 1.1 0 .29.05.56.18.79.13.23.3.41.52.53.22.12.47.18.72.18.41 0 .77-.12 1.04-.41.28-.29.39-.67.39-1.1 0-.29-.05-.55-.18-.79-.12-.22-.29-.4-.51-.52-.22-.12-.46-.18-.72-.18z"
  }), _react.default.createElement("path", {
    d: "M11.9992 11.0003c.6619 0 1.1984-.473 1.1984-1.2658 0-.8126-.5365-1.2658-1.1984-1.2658-.6619 0-1.1984.4613-1.1984 1.2658 0 .7955.5365 1.2658 1.1984 1.2658z"
  })];
};

exports.default = _default;